<script setup lang="ts">
  import { inject, onMounted, ref } from 'vue';
  import type { Ref } from 'vue';

  import { FileDropzoneKey } from '@/components/file-upload-dropzone';
  import type { FileDropzoneProviderContext } from '@/components/file-upload-dropzone';

  const context = inject<FileDropzoneProviderContext>(FileDropzoneKey)!;
  const dropzoneContentRef = ref<HTMLDivElement>();

  onMounted(() => {
    if (dropzoneContentRef.value && !context.disabled?.value) {
      context.setupDropZone(dropzoneContentRef as Ref<HTMLDivElement>);
    }
  });
</script>

<template>
  <div ref="dropzoneContentRef">
    <slot
      v-bind="{
        openFileInput: context.openFileInput,
        fileAttachments: context.fileAttachments.value,
        isOverDropZone: context.isOverDropZone.value,
        isSingleUploadLimitReached: context.isSingleUploadLimitReached.value,
      }"
    />
  </div>
</template>

<style scoped></style>
